var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.error.length > 0),expression:"error.length > 0"}],staticClass:"input-warning-text"},[_c('base-icon',{attrs:{"iconRef":"alert-circle","position":"left"}}),_vm._v("\n  "+_vm._s(_vm.error)+"\n")],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b746e59","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base-components/base-input-warning.vue
// module id = null
// module chunks = 